import React, { Component } from 'react';
import '../../../stylesheets/document.scss'
import BootstrapTable from 'react-bootstrap-table-next';
import { changePath } from '../../../utils/common'

export default class Exception extends Component {
    state = {
        header: 'Error Codes',
        data: [{ key: "TokenException ", description: "Preceded by a 403 header, this indicates the expiry or invalidation of an authenticated session. This can be caused by the user logging out, a natural expiry, or the user logging into another Kite instance. When you encounter this error, you should clear the user's session and re-initiate a login. " }, { key: "UserException ", description: "Represents user account related errors " }, { key: "OrderException ", description: "Represents order related errors such placement failures, a corrupt fetch etc " }, { key: "InputException ", description: "Represents missing required fields, bad values for parameters etc. " }, { key: "NetworkException ", description: "Represents a network error where the API was unable to communicate with the OMS (Order Management System) " }, { key: "DataException ", description: "Represents an internal system error where the API was unable to understand the response from the OMS to inturn respond to a request " }, { key: "GeneralException ", description: "Represents an unclassified error. This should only happen rarely " }],
        columns: [

            {
                dataField: 'key',
                text: 'Exception',


            },

            {
                dataField: 'description',
                text: 'Description',


            },


        ],
        errdata: [{ key: "1", code: "AG8001", description: "Invalid Token" }, { key: "2", code: "AG8002", description: "Token Expired " }, { key: "3", code: "AG8003", description: "Token missing " }, { key: "4", code: "AB8050", description: "Invalid Refresh Token " }, { key: "5", code: "AB8051", description: "Refresh Token Expired " }, { key: "6", code: "AB1000", description: "Invalid Email Or Password " }, { key: "7", code: "AB1001", description: "Invalid Email " }, { key: "8", code: "AB1002", description: "Invalid Password Length " }, { key: "9", code: "AB1003", description: "Client Already Exists " }, { key: "10", code: "AB1004", description: "Something Went Wrong, Please Try After Sometime " }, { key: "11", code: "AB1005", description: "User Type Must Be USER " }, { key: "12", code: "AB1006", description: "Client Is Block For Trading " }, { key: "13", code: "AB1007", description: "AMX Error " }, { key: "14", code: "AB1008", description: "Invalid Order Variety " }, { key: "15", code: "AB1009", description: "Symbol Not Found " }, { key: "16", code: "AB1010", description: "AMX Session Expired " }, { key: "17", code: "AB1011", description: "Client not login " }, { key: "18", code: "AB1012", description: "Invalid Product Type " }, { key: "19", code: "AB1013", description: "Order not found " }, { key: "20", code: "AB1014", description: "Trade not found " }, { key: "21", code: "AB1015", description: "Holding not found " }, { key: "22", code: "AB1016", description: "Position not found " }, { key: "23", code: "AB1017", description: "Position conversion failed " }, { key: "24", code: "AB1018", description: "Failed to get symbol details " }, { key: "25", code: "AB2000", description: "Error not specified " }, { key: "26", code: "AB2001", description: "Internal Error, Please try after sometime" }, { key: "27", code: "AB1031", description: "Old Password Mismatch" }, { key: "28", code: "AB1032", description: "User Not Found" }, { key: "29", code: "AB2002", description: "ROBO order is block" }, { key: "30", code: "AB4008", description: "ordertag length should be less than 20 characters" }],
        errcolumns: [

            {
                dataField: 'key',
                text: 'Sr. No',


            },
            {
                dataField: 'code',
                text: 'Error Code',


            },
            {
                dataField: 'description',
                text: 'Description',


            },


        ]
    }
    componentDidMount() {
        // window.location.href='#top'
    }
    render() {
        const { header, data, columns, errcolumns, errdata } = this.state
        return (
            <div className="doc-row" id="/docs/Exceptions">
                        <div className="doc-left">
            <div className='container-fluid font mb-5' id="top">
                <h1>{header}</h1>
                <p>Error responses come with the name of the exception generated internally by the API server. You can define corresponding exceptions in your language or library, and raise them by doing a switch on the returned exception name. </p>
                {/* <h4>Exceptions: </h4>
                <BootstrapTable
                    hover
                    keyField='id'
                    data={data}
                    columns={columns}
                    wrapperClasses={'react-bootstrap-table1'}
                    headerClasses="font"
                /> */}
                        <h2>Error Codes and Description: </h2>
                        <BootstrapTable
                            hover
                            keyField='id'
                            data={errdata}
                            columns={errcolumns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />

                        <div class="row">
                            <div class="col-md-6">
                            <i class=" changePrevious-Button fas fa-chevron-circle-left" title="Previous" onClick={()=>changePath('/docs/ResponseStructure')}></i>

                                {/* <input style={{ float: 'left' }} type="button" className="btn btn-primary btn-lg m-t-5" onClick={() => changePath('/docs/ResponseStructure')} value='<< Previous' /> */}
                            </div>
                            <div class="col-md-6">
                            <i class=" changeNext-Button fas fa-chevron-circle-right" title="Next" onClick={()=>changePath('/docs/User')}></i>

                                {/* <input style={{ float: 'right' }} type="button" className="btn btn-primary btn-lg m-t-5" onClick={() => changePath('/docs/User')} value='Next >>' /> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
